/**
 * Sending a message via postMessage
 * @param {string} type - message type
 * @param {string} data - data to send
 * @param {string} [targetOrigin = '*']
 */
export function sendMessage(type, data, targetOrigin = '*') {
    try {
        const message = {
            [type]: data,
        };

        parent?.postMessage(JSON.stringify(message), targetOrigin);
    } catch (error) {
        console.error('Failed to send postMessage:', error);
    }
}
